<div class="voices-top-section">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <div class="app-l-page__breadcrumbs">
                <ul class="breadcrumbs-list">
                    <li translate class="breadcrumbs-list-item">
                        <a [routerLink]="['/app/series']" translate
                            >series.title</a
                        >
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        translate>
                        series.seriesTypes.audio
                    </li>
                </ul>
            </div>
        </div>
        <div class="app-l-voices-banner">
            <div class="app-l-voices-banner__left">
                <h1 class="app-l-voices-banner__heading" translate>
                    series.seriesTypes.audio
                </h1>
                <!-- <h6 class="app-l-voices-banner__desc" translate>
                    Lorem ipsum dolor sit amet consectetur. Tortor sit vel.
                </h6> -->
            </div>
        </div>
    </div>
</div>
<div class="voice-series-main-container">
    <div class="series-type-section">
        <div class="series-type-list">
            <div
                class="series-type-card stories"
                *ngIf="enableStorySeries"
                (click)="goToVoiceSeries('stories')">
                <div class="cover-image-section">
                    <img [src]="'../../../assets/img/series/storiesBg.svg'" />
                </div>
                <div class="card-content" translate>
                    series.voiceSeries.stories
                </div>
            </div>
            <div
                class="series-type-card burning_questions"
                *ngIf="enableBurningQuestionSeries"
                (click)="goToVoiceSeries('burningQuestions')">
                <div class="cover-image-section">
                    <img [src]="'../../../assets/img/series/voiceBg.svg'" />
                </div>
                <div class="card-content" translate>
                    series.voiceSeries.burningQuestions
                </div>
            </div>
        </div>
    </div>
</div>
